import {
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../../../components/modal/Dialog";
import {
  TableLegacy,
  TableLegacyContainer,
  TableLegacyTHead,
  TableLegacyTR,
  TableLegacyTH,
  TableLegacyTBody,
  TableLegacyTD,
} from "../../../../../components/table/TableLegacy";
import { useAvailabilityTierList } from "../../../../../hooks/api/v2/availabilityTier/useAvailabilityTierList";
import { Button, Icon } from "@sellar-io/components";
import { useProductAvailabilityTierBatchCreate } from "../../../../../hooks/api/v2/productAvailabilityTier/useProductAvailabilityTierBatchCreate";

export default function ItemVisibilityDialogContent({
  onDismiss,
  productId,
  onBack,
  onSubmit,
  selectedIds,
  setSelectedIds,
}: {
  productId: number;
  onDismiss: () => void;
  onBack: () => void;
  onSubmit: () => void;
  selectedIds: number[];
  setSelectedIds: (ids: number[]) => void;
}) {
  const availabilityTierListQuery = useAvailabilityTierList({
    limit: 50,
    query: [
      {
        type: "ProductId",
        modifier: "EQUALS",
        value: productId,
      },
    ],
  });

  const toggleAvailabilityTier = (id: number) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };

  const productAvailabilityTierBatchCreateMutation =
    useProductAvailabilityTierBatchCreate();

  return (
    <div>
      <DialogContent>
        <DialogNavigation
          title="Item visibility"
          description="Add this product to the product catalogues you would like it to be visible in."
          leftIcon={"CHEVRON_DOWN"}
          onClickLeftIcon={() => onDismiss()}
        />

        <div className={"flex flex-col gap-4"}>
          <div className="flex flex-col gap-2">
            <TableLegacyContainer className={"max-h-[300px]"}>
              <TableLegacy>
                <TableLegacyTHead>
                  <TableLegacyTR>
                    <TableLegacyTH className={"sticky top-0"}>
                      Product catalogue
                    </TableLegacyTH>
                    <TableLegacyTH className={"sticky top-0"}>
                      Visible
                    </TableLegacyTH>
                  </TableLegacyTR>
                </TableLegacyTHead>
                <TableLegacyTBody>
                  {availabilityTierListQuery.data?.pages.map((page) =>
                    page.map((availabilityTier) => (
                      <TableLegacyTR key={availabilityTier.id}>
                        <TableLegacyTD>{availabilityTier.name}</TableLegacyTD>
                        <TableLegacyTD>
                          <input
                            type="checkbox"
                            checked={selectedIds.includes(availabilityTier.id)}
                            onChange={() =>
                              toggleAvailabilityTier(availabilityTier.id)
                            }
                          />
                        </TableLegacyTD>
                      </TableLegacyTR>
                    )),
                  )}
                </TableLegacyTBody>
              </TableLegacy>
            </TableLegacyContainer>
          </div>
        </div>
      </DialogContent>
      <DialogCTA className="flex items-center justify-between">
        <Button color="tertiary" type="button" onClick={onBack}>
          <div className="flex">
            <Icon icon="CHEVRON_LEFT" />
            <div>Back</div>
          </div>
        </Button>
        <Button
          loading={productAvailabilityTierBatchCreateMutation.isPending}
          onClick={onSubmit}
        >
          Confirm
        </Button>
      </DialogCTA>
    </div>
  );
}
